import type { Entity } from './api.js';

/**
 * **Ce que la fiche décide de la description automatique** *(R6, 2026-09-13)* — pur,
 * pour être mesuré sans navigateur (`recherche.spec.ts`).
 */

export type DescribedField = 'Description' | 'Tags';

/** Le champ est-il **encore tenu** par la machine ? — `Described.Machine`, servi au propriétaire. */
export const heldByMachine = (entity: Entity, field: DescribedField): boolean =>
  entity.Described?.Machine?.includes(field) === true;

/**
 * **Y a-t-il une correction à perdre ?** — la question que « Régénérer » pose avant
 * d'écraser (Q3). Un champ **présent** que la machine ne tient pas est une
 * correction : posé à l'envoi, ou corrigé depuis. Un champ vide n'a rien à perdre,
 * et un champ que la machine tient encore non plus — le réécrire est le geste même.
 */
export function hasCorrections(entity: Entity): boolean {
  const present: Record<DescribedField, boolean> = {
    Description: Boolean(entity.Description),
    Tags: (entity.Tags?.length ?? 0) > 0,
  };
  return (['Description', 'Tags'] as const).some(
    (field) => present[field] && (entity.Described === undefined || !heldByMachine(entity, field)),
  );
}
